var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/pages/admin_page.tsx";
import React from 'react';
import { Layout } from 'soapbox/components/ui';
import BundleContainer from 'soapbox/features/ui/containers/bundle_container';
import { LatestAccountsPanel } from 'soapbox/features/ui/util/async-components';
import LinkFooter from '../features/ui/components/link_footer';
const AdminPage = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: LatestAccountsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 25
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(LinkFooter, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  })));
};
export default AdminPage;